export const dateKey = "Select date";
export const SELECT_DATE_PLACEHOLDER = "Select date";
export const SELECT_TIME_PLACEHOLDER = "Select time";
export const SELECT_BATCH_PLACEHOLDER = "Select a batch";
export const MIN_SELECTED_QUANTITY_FOR_MERCHANDISE = 2;
export const INITIAL_DATA_TYPE = {
  PLAN: "plan",
  LISTING: "listing",
};

export const ADD_CUSTOMER_LABELS = {
  DEFAULT_TITLE: "Add a new booking",
  DEFAULT_PRIMARY_BTN_TEXT: "Add Booking",
};

export const DISABLE_OFFERING_DEFAULT = false;
export const DISABLE_AMOUNT_DEFAULT = false;
export const REQUIRE_SLOT_TIME_VALIDATION_DEFAULT = false;
export const REQUIRE_SLOT_VALIDATION_DEFAULT = false;
export const REQUIRE_BATCH_VALIDATION_DEFAULT = false;
export const IS_QR_FLOW_DEFAULT = false;
export const EMPTY_BATCH_UUID = "";

export const ALLOWED_INITIAL_FORM_KEYS = [
  "full_name",
  "email",
  "phone",
  "customer_phone_number",
  "country_code",
  "country",
  "listing_uid",
  "entity_uuid",
  "amount",
  "send_comms",
  "send_installment_comms",
  "selected_quantity",
  "selected_price",
  "currency",
  "selected_appointment_slots",
  "appointment_slots",
  "selected_batch",
  "available_currencies",
  "listing_data",
  "entity_data",
  "payment_type",
  "address_details",
  "customer_timezone",
  "booking_start_date",
  "membership_uuid",
  "offering_variant_uuid",
  "installments",
  "note",
  "payment_mode_uuid",
  "gateway_transaction_id",
  "customer_gst_details",
  "gst_number",
  "gst_name",
  "billing_state",
  "tag_uuids",
  "tag_name",
  "payment_mode_name",
  "map_zoom_attendance",
  "participant_email",
  "class_uid",
  "slot_uids",
];
